export default __webpack_public_path__ + "static/media/poster-sdg-14.88334e07.png";